import React, {Component} from 'react';

import moment from 'moment';
import swal from 'sweetalert2';

import urls from "../../../utils/urls";
import {apiToken} from "../../../utils/headers";
import {Spinner} from '../../../components/Loading/Spinner';
import Datepicker from "../../../components/Datepicker/datepicker";

export default class ReporStock extends Component {

    constructor(props) {
        super(props);
        this.state = {
            ajaxInProgress: false,
            type: 'stock',
            unload_finished_at_gte: '',
            unload_finished_at_lte: ''
        }
    }
    _handleDateChange = (prop, value) => {
        let dateParts = value.split("-");
        let newValue = `${dateParts[0]}-${dateParts[1]}-01`;
        this.setState({[prop]: newValue});
    };

    _emptyFilters = () => {
        this.setState({unload_finished_at_gte: '', unload_finished_at_lte: ''});
    };

    _generateReport = () => {

        let {type, unload_finished_at_gte, unload_finished_at_lte} = this.state;

        let REPORT_URL = `${urls.API_ROOT}/api/v1/reports/?type=${type}`;
        if(unload_finished_at_gte) REPORT_URL += `&unload_finished_at_gte=${unload_finished_at_gte}`;
        if(unload_finished_at_lte) REPORT_URL += `&unload_finished_at_lte=${unload_finished_at_lte}`;

        if(unload_finished_at_gte && unload_finished_at_lte && unload_finished_at_gte >= unload_finished_at_lte){

            swal({
                title: 'Filtros inválidos',
                html: 'Por favor ingrese un período válido de filtro para generar su reporte',
                type: 'error'
            });

            return false;
        }
        this.setState({ajaxInProgress: true});

        try{
            let xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function () {
                let a;
                if (xhttp.readyState === 4 && xhttp.status === 200) {
                    this._onSubmitSuccess();
                    let filename = `Reporte de stock - ${moment().format('DD-MM-YYYY')}.xlsx`;
                    if (navigator.appVersion.toString().indexOf('.NET') > 0) {
                        //IE 10+
                        window.navigator.msSaveBlob(xhttp.response, filename);
                    }else{
                        // Trick for making downloadable link
                        a = document.createElement('a');
                        a.href = window.URL.createObjectURL(xhttp.response);
                        // Give filename you wish to download
                        a.download = filename;
                        a.style.display = 'none';
                        document.body.appendChild(a);
                        a.click();
                    }
                }else if(xhttp.status >= 300){
                    this._onSubmitError();
                }
            }.bind(this);
            // Post data to URL which handles post request
            xhttp.open("GET", REPORT_URL);
            xhttp.setRequestHeader("Authorization", `Token ${apiToken()}`);
            // You should set responseType as blob for binary responses
            xhttp.responseType = 'blob';
            xhttp.send();
        }
        catch(e){
            console.log(e);
        }

    };

    _onSubmitSuccess = () => {
        this.setState({ajaxInProgress: false});
        swal({
            title: 'Reporte creado',
            html: 'El reporte ha sido creado correctamente. Espere unos segundos mientras se descarga',
            type: 'success',
            showConfirmButton: false,
            timer: 3000
        });
    };

    _onSubmitError = () => {
        this.setState({ajaxInProgress: false});
        swal({
            title: 'No se ha podido crear el reporte',
            html: 'Por favor, vuelva a intentarlo nuevamente',
            type: 'error'
        });
    };


    render() {

        let {unload_finished_at_gte, unload_finished_at_lte, ajaxInProgress} = this.state;

        let buttonDisabled = (ajaxInProgress);

        let today = moment().startOf('month').format('YYYY-MM-DD');

        return (
            <div>
                <div className={'filter'}>
                    <div className={'row thin-row'}>
                        <div className={'col s4 m3 input-field'}>
                            <Datepicker value={unload_finished_at_gte} format={"YYYY-MM-DD"}
                                        openAction={() => {
                                            if(!unload_finished_at_gte) this.setState({unload_finished_at_gte: today});
                                        }}
                                        pickerFormat={"mm/yyyy"} momentFormat={"MM/YYYY"} hideDays={true}
                                        id="unload_finished_at_gte" action={this._handleDateChange}
                                        classname="" style={{position: 'relative', marginTop: 15}}/>
                            <label className={"active"}>Fecha de descarga</label>
                        </div>
                        <div className={'col s4 m3 input-field'}>
                            <div style={{position: 'absolute', left: 0, top: 13}}>
                                <p style={{position: 'absolute'}}>a</p>
                            </div>
                            <Datepicker value={unload_finished_at_lte} format={"YYYY-MM-DD"}
                                        openAction={() => {
                                            if(!unload_finished_at_lte) this.setState({unload_finished_at_lte: today});
                                        }}
                                        pickerFormat={"mm/yyyy"} momentFormat={"MM/YYYY"} hideDays={true}
                                        id="unload_finished_at_lte" action={this._handleDateChange}
                                        classname="" style={{position: 'relative', marginTop: 15, marginLeft: 10}}/>
                            <label className={"active"} />
                        </div>
                        <div className={'col s4 m6 text-right'}>
                            <div onClick={this._emptyFilters} className={"pointer"} style={{
                                color: "#000000",
                                fontWeight: 'bold',
                                marginTop: 58
                            }}>
                                Borrar filtros
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"text-right"}>
                    <button onClick={this._generateReport}
                            className={`no-margin btn btn-shell-empty z-depth-0 ${buttonDisabled ? 'disabled' : ''}`}>
                        Generar Reporte
                    </button>
                </div>
                {ajaxInProgress &&
                <div className={"text-center"}><Spinner/></div>
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Reports/ReportStock.js